import pdfExport from './utils/pdfExport.js';

const masterInput = document.getElementById('master');
const stockInput = document.getElementById('stock');
const submitButton = document.getElementById('generateButton');
const notificationsDiv = document.getElementById('notifications');

submitButton.addEventListener('click', async () => {
	notificationsDiv.innerHTML = '';

	const masterFile = masterInput.files[0];
	const stockFile = stockInput.files[0];

	if (!masterFile || !stockFile) {
		notificationsDiv.innerHTML = 'Error: Please upload both the masterfile and the stockfile.';
	}

	try {
		await pdfExport(masterFile, stockFile)
	} catch (error) {
		console.log('Error: ', error);
		notificationsDiv.innerHTML = error;
	}
});
